import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";
import { cn } from "@/lib/cn";

const THEME_KEY = "sicen-theme";

function isDarkNow(): boolean {
  return document.documentElement.classList.contains("dark");
}

/**
 * Conmutador claro/oscuro. El tema inicial lo resuelve el script pre-paint de
 * index.html (preferencia guardada > preferencia del sistema); aquí solo se
 * alterna la clase `dark` del root y se persiste la elección explícita.
 */
export function ThemeToggle({ className }: { className?: string }) {
  const [dark, setDark] = useState(isDarkNow);

  useEffect(() => {
    document.documentElement.classList.toggle("dark", dark);
  }, [dark]);

  const toggle = () => {
    const next = !dark;
    setDark(next);
    try {
      localStorage.setItem(THEME_KEY, next ? "dark" : "light");
    } catch {
      /* almacenamiento no disponible: el tema aplica solo a la sesión */
    }
  };

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={dark ? "Cambiar a tema claro" : "Cambiar a tema oscuro"}
      title={dark ? "Tema claro" : "Tema oscuro"}
      className={cn("cursor-pointer rounded p-2 transition", className)}
    >
      {dark ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
    </button>
  );
}
